module.exports = __webpack_public_path__ + "static/media/sexually-transmitted-disease-icon-first-lithonia-medical.745e97d1.jpg";